import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';

import { showModal } from '../actions';

const VideoShowcase = ({
  openModal,
  thumbnail,
  video,
  title,
  small,
}) => {
  const [iconSize, setIconSize] = useState(0);
  const videoRef = useRef(null);

  const handleSize = useCallback(() => {
    if (videoRef.current) {
      const height = videoRef.current.offsetHeight;
      setIconSize(parseInt(height * 0.3));
    }
  }, []);

  useEffect(() => {
    const videoElement = videoRef.current;

    if (!videoElement) return () => {};

    const resizeObserver = new ResizeObserver(handleSize);
    resizeObserver.observe(videoElement);

    return () => {
      resizeObserver.unobserve(videoElement);
    };
  }, [handleSize]);

  return (
    <>
      {/* eslint-disable jsx-a11y/click-events-have-key-events */}
      {/* eslint-disable jsx-a11y/no-static-element-interactions */}
      <div
        className={classnames('video-showcase', { 'video-showcase-small': small })}
        onClick={() => openModal(video, title)}
        ref={videoRef}
      >
        <img src={thumbnail} alt={title} />
        <div className="video-showcase-icon-wrapper" style={{ fontSize: iconSize }}>
          <i className="far fa-circle-play" />
        </div>
      </div>
      {/* eslint-enable jsx-a11y/click-events-have-key-events */}
      {/* eslint-enable jsx-a11y/no-static-element-interactions */}
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  openModal: (url, title) => {
    dispatch(showModal('VideoPlayerModal', {
      className: 'modal-video-player',
      url,
      title,
      backdrop: true,
    }));
  },
});

VideoShowcase.propTypes = {
  openModal: PropTypes.func.isRequired,
  thumbnail: PropTypes.string.isRequired,
  video: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  small: PropTypes.bool,
};

VideoShowcase.defaultProps = {
  small: false,
};

export default connect(null, mapDispatchToProps)(VideoShowcase);
